export default __webpack_public_path__ + "static/dot-pattern-cream-0dec09a0d165afd46b04be5176294f26.svg";